module.exports = __webpack_public_path__ + "img/ironworker-skills-logo.9d54865a.jpg";